import * as THREE from 'three'
import { Reflector } from 'three/examples/jsm/objects/Reflector'
import Experience from '../Experience'
export default class Floor {
  constructor() {
    //setup
    this.experience = new Experience()
    this.scene = experience.scene
    this.resources = experience.resources

    this.setGeometry()
    this.setTexture()
    this.setMaterial()
    this.setMesh()
  }

  setGeometry() {
    this.floor1 = new THREE.CircleGeometry(5, 64)

    this.floor2 = new THREE.CircleGeometry(5, 64)
    this.groundMirror = new Reflector(this.floor2, {
      clipBias: 0.003,
      color: 0x777777,
    })
    this.groundMirror.position.y = -0.001
    this.groundMirror.rotateX(-Math.PI / 2)
    this.scene.add(this.groundMirror)
  }
  setTexture() {
    this.floorTextures = {}

    //floor materials
    this.floorTextures.color = this.resources.items.marbleColor
    this.floorTextures.color.encoding = THREE.sRGBEncoding
    this.floorTextures.color.repeat.set(1.5, 1.5)
    this.floorTextures.color.wrapS = THREE.RepeatWrapping
    this.floorTextures.color.wrapT = THREE.RepeatWrapping

    this.floorTextures.normal = this.resources.items.marbleNormal
    this.floorTextures.normal.encoding = THREE.sRGBEncoding
    this.floorTextures.normal.repeat.set(1.5, 1.5)
    this.floorTextures.normal.wrapS = THREE.RepeatWrapping
    this.floorTextures.normal.wrapT = THREE.RepeatWrapping

    this.floorTextures.roughness = this.resources.items.marbleRoughness
    this.floorTextures.normal.encoding = THREE.sRGBEncoding
    this.floorTextures.normal.repeat.set(1.5, 1.5)
    this.floorTextures.normal.wrapS = THREE.RepeatWrapping
    this.floorTextures.normal.wrapT = THREE.RepeatWrapping
  }
  setMaterial() {
    this.material = new THREE.MeshStandardMaterial({
      map: this.floorTextures.color,
      normalMap: this.floorTextures.normal,
      opacity: 0.9,
      transparent: true,
    })
  }
  setMesh() {
    this.mesh = new THREE.Mesh(this.floor1, this.material)
    this.mesh.position.y = 0
    this.mesh.rotation.x = -Math.PI * 0.5
    this.mesh.receiveShadow = true
    this.scene.add(this.mesh)
  }
}
